import React, { useContext, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import isBetween from "dayjs/plugin/isBetween";
import { useMutation } from "@apollo/client";
import dayjs from "dayjs";

import { TextField } from "@mui/material";

import { LicenseTypes, Operation } from "../../../../utils/Enum.types";

import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import { msgType } from "../../../../utils/types";
import {
  RefsByTagName,
  toInputStandardDate,
  toIsoDate,
} from "../../../../utils/UtilFunctions";
import Navbar from "../../../common/layout/Navbar";
import { Title } from "../../../../stories/Title/Title";
import { Label } from "../../../../stories/Label/Label";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../utils/Enum.keys";
import { EMPTY_STRING } from "../../../../utils/constants";
import Input from "../../../../stories/Input/Input";
import { Button } from "../../../../stories/Button/Button";
import MessageModal from "../../../../customComponents/MessageModal";
import FinancialYearList from "./FinancialYearList";
import { AddFinYr } from "./queries/mutations";
import { AddFinYrResult, AddFinYrVars } from "./queries/types";
import useUrlParams from "../../../../customHooks/useUrlParams";
import { GetFinYrs } from "./queries/queries";
import Steps from "../Steps";
import Close from "../../../../images/Close.svg";
import { AppContext } from "../../../../context/context";

interface Props {
  operation: Operation;
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
  steps: boolean;
}
dayjs.extend(isBetween);
const FinancialYear = ({ operation, setModal, steps }: Props) => {
  const navigate = useNavigate();

  const { user_details } = useLoggedInUserDetails();

  const { customer_id } = useUrlParams();

  const { state } = useContext(AppContext);

  const [startDate, setStartDate] = useState("");

  const [endDate, setEndDate] = useState("");

  const [message, setMessage] = useState<msgType>({
    message: "",
    flag: false,
    operation: Operation.NONE,
  });
  //userefs
  const saveRef = useRef<HTMLButtonElement>(null);

  const chooseFinYearRef = useRef<HTMLSelectElement | HTMLInputElement>(null);
  const finYrInputRef = RefsByTagName(chooseFinYearRef);

  const [selectedFinancialYear, setSelectedFinancialYear] = useState("");

  //lazy queries

  const [newFinancialYear] = useMutation<AddFinYrResult, AddFinYrVars>(
    AddFinYr,
    {
      onError: (e) =>
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        }),
    }
  );
  const upcommingFinancialYears = () => {
    var currentYear = new Date().getFullYear();

    return [...new Array(2).keys()].map((i) => {
      const start = dayjs(`04-01-${currentYear}`).add(i, "year").format();
      const endYear = currentYear + 1 + i;
      const end = dayjs(`03-31-${endYear}`).format();

      return {
        label: `${dayjs(start).format("YYYY")}-${dayjs(end).format("YYYY")}`,
        value: {
          startDate: start,
          endDate: end,
        },
      };
    });
  };

  const OldFinancialYears = () => {
    var currentYear = new Date().getFullYear();

    return [...new Array(15).keys()].map((i) => {
      const start = dayjs(`04-01-${currentYear - 1}`)
        .subtract(i, "year")
        .format();
      const endYear = currentYear - i;
      const end = dayjs(`03-31-${endYear}`).format();

      return {
        label: `${dayjs(start).format("YYYY")}-${dayjs(end).format("YYYY")}`,
        value: {
          startDate: start,
          endDate: end,
        },
      };
    });
  };

  const handleClose = () => {
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });

    finYrInputRef?.focus();
  };

  const years = [...upcommingFinancialYears(), ...OldFinancialYears()];
  const result = years.filter(({ label }) => label === selectedFinancialYear);

  years.sort(
    (a, b) =>
      new Date(a.value.startDate).valueOf() -
      new Date(b.value.startDate).valueOf()
  );

  const HandleNewFinancialYear = async (e: React.FormEvent) => {
    e.preventDefault();
    if (customer_id || state.customerId)
      newFinancialYear({
        variables: {
          customerID: customer_id ? customer_id : state.customerId,
          input: {
            fin_yr: result[0].label,
            fin_st_date: result[0].value.startDate,
            fin_end_date: toIsoDate(endDate),
          },
          user_details,
        },
        refetchQueries: [
          {
            query: GetFinYrs,
            variables: {
              customerID: customer_id ? customer_id : state.customerId,
              companyID: 0,
            },
          },
        ],
      }).then(({ data }) => {
        if (data) {
          setMessage({
            message: "Financial Year Added Successfully",
            flag: true,
            operation: Operation.CREATE,
          });
        }
      });
    setSelectedFinancialYear("");
  };

  return (
    <>
      {operation === Operation.CREATE && (
        <>
          <Navbar NavType={LicenseTypes.CUSTOMER} />
          <Title>Financial Year</Title>
          {steps ? <Steps step={2} /> : ""}
        </>
      )}
      {operation === Operation.UPDATE && (
        <div className="fin-yr__title">
          <Title>Financial Year</Title>

          <img
            src={Close}
            alt=""
            onClick={() => {
              // hanldeClear();
              setModal(false);
            }}
          />
        </div>
      )}

      <form
        className={
          operation === Operation.UPDATE
            ? `fin-yr__edit`
            : steps
            ? "fin-yr__add"
            : `fin-yr`
        }
        onSubmit={HandleNewFinancialYear}
      >
        <div className="fin-yr__datablock row g-0">
          <div className="col fin-yr__datablock--left-frame">
            <Title variant="subtitle1">Add Financial Year</Title>
            <div className="fin-yr__datablock--tableblock">
              <div className="label-grid">
                <Label>Choose Financial Year</Label>
                <FormAutocomplete
                  className={formClasses.inputRoot}
                  ref={chooseFinYearRef}
                  onKeyDown={(e) => {
                    if (e.key === Keys.ENTER) {
                      e.preventDefault();

                      if (selectedFinancialYear) {
                        saveRef?.current?.focus();
                      }
                    }
                    if (e.key === Keys.BACKSPACE) {
                      setSelectedFinancialYear(EMPTY_STRING);
                    }
                  }}
                  options={years}
                  openOnFocus
                  forcePopupIcon
                  value={
                    years?.find(
                      ({ label }) => label === selectedFinancialYear
                    ) ?? null
                  }
                  onChange={(e, newValue) => {
                    if (newValue) {
                      setSelectedFinancialYear(
                        (newValue as { label: string }).label
                      );
                      const selectedStartDate = (
                        newValue as { value: { startDate: string } }
                      ).value.startDate;
                      setStartDate(toInputStandardDate(selectedStartDate));

                      let endDate = dayjs(selectedStartDate).add(364, "day");

                      const year = dayjs(selectedStartDate).year();
                      const leapDay = dayjs(`${year}-02-29`);
                      if (
                        leapDay.isValid() &&
                        leapDay.isBetween(
                          selectedStartDate,
                          endDate,
                          null,
                          "[]"
                        )
                      ) {
                        endDate = endDate.add(1, "day");
                      }

                      setEndDate(endDate.format("YYYY-MM-DD"));
                    } else {
                      setSelectedFinancialYear(EMPTY_STRING);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      required
                      className={formClasses.formControlRoot}
                    />
                  )}
                />
              </div>

              <div className="label-grid">
                <Label>Start Date</Label>
                <Input
                  type="date"
                  value={startDate}
                  required
                  onChange={(e) => {
                    setStartDate(e.target.value);
                    setEndDate(
                      dayjs(e.target.value).add(364, "day").format("YYYY-MM-DD")
                    );
                  }}
                />
              </div>

              <div className="label-grid">
                <Label>End Date</Label>
                <Input
                  type="date"
                  value={selectedFinancialYear ? endDate : ""}
                  required
                  disabled
                />
              </div>
            </div>
          </div>
          <FinancialYearList onlyTable={true} />
        </div>
        <Button mode="save" type="submit" buttonref={saveRef} />

        {operation === Operation.CREATE && (
          <>
            {steps ? (
              <Button
                mode="move-next"
                type="button"
                onClick={() => navigate(`/${customer_id}/assigncustomerrights`)}
              />
            ) : (
              ""
            )}
            <Button
              mode="clear"
              type="button"
              onClick={() => setSelectedFinancialYear("")}
            />

            <Button mode="back" onClick={() => navigate(-1)} />
          </>
        )}
        {operation === Operation.UPDATE && (
          <Button mode="cancel" onClick={() => setModal(false)} />
        )}
      </form>

      {/* <LoadingModal flag={creationLoading} /> */}
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />
      {/* <Modal
        shouldCloseOnOverlayClick={true}
        isOpen={configurationModal}
        style={ConfigurationsModalStyles}
        ariaHideApp={false}
      >
        <div className="modal-flex h-100">
          <div className="modal-flex__data h-100">
            <ConfigurationSettings
              pageNumber={PageNumbers.FINANCIAL_YEAR_PAGE}
              setModalFlag={setConfigurationModal}
            />
          </div>
          <div className="modal-flex__image">
            <img
              src={Close}
              alt="/"
              onClick={() => setConfigurationModal(!configurationModal)}
            />
          </div>
        </div>
      </Modal> */}
    </>
  );
};

export default FinancialYear;
